import * as React from 'react'

import DividerComp from '../../components/DividerComp/DividerComp'
import Image from '../../components/Image/Image'
import type { ImageViewModel } from '../../view-models/ImageViewModel'
import styles from './imageAndTextblock-style.css'

type Props = {
  image: ImageViewModel
}
type State = {}

class ImageAndTextblock extends React.Component<Props, State> {
  static displayName = 'ImageAndTextblock'
  static defaultProps = {}

  render() {
    const { image } = this.props

    return (
      <div className={styles.container}>
        <Image {...image} className={styles.imageWrapper} />
        <DividerComp />
      </div>
    )
  }
}

export default ImageAndTextblock